export function vatText(vatIncluded: boolean): string {
  return vatIncluded ? __('vat.included') : __('vat.not_included');
}
